import { appEmitter } from "../../emitter";
import { SmsEvent } from "./vue/utlis/captcha/config";

/**
 * Проверяет верификацию смс кодом
 * Отправляет событие открытия окна капчи с вводом смс кода и резолвится, если ловит событие успешного ввода смс
 * @param {string} endpoint
 * @param {string} phone
 * @param {boolean=} force
 * @param {boolean=} noPhone - если сессия подтверждена другим способом и фронт не знает номер телефона (например, черновик вкладов)
 */
export const waitPhoneCode = async (endpoint, phone, force, noPhone) => {
  if ( (!endpoint || !phone) && !noPhone ) throw new Error('endpoint & phone arguments is required');
  await new Promise((resolve, reject) => {
    appEmitter.once(SmsEvent.ON_CONFIRMED, resolve);
    appEmitter.once(SmsEvent.ON_CLOSED, () => reject('sms modal closed'));
    appEmitter.emit(SmsEvent.ON_GET_PHONE_CODE, { endpoint, phone, force });
  });
}

/**
 * Для обработки ошибок методов, требующих sms верификацию
 *
 * Если статус 419 или 403 то
 *
 * Запросить смс код
 *
 * иначе вернуть обратно ошибку
 * @param {object} err
 * @param {string} endpoint
 * @param {string} phone
 */
export const handleOtpExpired = async (err, endpoint, phone) => {
  if ([419, 403].includes(err.response?.status)) {
    await waitPhoneCode(endpoint, phone, true);
    return err.retry();
  }

  return Promise.reject(err);
}
